// Affiliate/partner campaign mapping
// Maps affiliate IDs to Leadspedia campaign credentials and Everflow tracking

export const campaignKeys = {
  '0': {
    lp_campaign_id: '66280997d0cd2',
    lp_campaign_key: 'zmv8MG2BhD6pJ3QWyLgr'
  },
  'fbr': { // E FB Rev Priority
    lp_campaign_id: '675c501ee686b',
    lp_campaign_key: 'cZpLC7hRz6MxTXP3G9wB'
  },
  'efb1': { // Elise FB 1
    lp_campaign_id: '675c501ee686b',
    lp_campaign_key: 'cZpLC7hRz6MxTXP3G9wB'
  },
  'efb2': { // Elise FB 2
    lp_campaign_id: '690587775efd5',
    lp_campaign_key: 'wcjngHNvVYzrT3B7x6Kk'
  },
  'efb3': { // Elise FB 3
    lp_campaign_id: '690587877af1f',
    lp_campaign_key: '8h2PJp4CQgWY69jwrBTt'
  },
  'efb4': { // Elise FB 4
    lp_campaign_id: '690587982d493',
    lp_campaign_key: 'wyr9DhVPk8JTnjYRB3zW'
  },
  'efb1e': { // Elise FB Employed
    lp_campaign_id: '690587afe7101',
    lp_campaign_key: '9yKFDPGZf8qtcLb72nzh'
  },
  'esf': { // Elise Short Form
    lp_campaign_id: '69e9f7ed6d55f',
    lp_campaign_key: 'yNPDx8M2HbWjmTQKcZd9'
  },
  'jsf': { // Justine Short Form
    lp_campaign_id: '69b33d73d7486',
    lp_campaign_key: 'hP4jLgNX37tHrRqv2xk8'
  },
  'fbet': { // E FB Employed Test
    lp_campaign_id: '68ff8d3892306',
    lp_campaign_key: 'JDntk2QGbCp8Bdwhv7Ry'
  },
  'efbn': { // E FB New (97)
    lp_campaign_id: '67a3b5192b975',
    lp_campaign_key: '4mT6pKnbjhx7GcqzY8BP'
  },
  'jafb': { // James FB 1
    lp_campaign_id: '68f998663a9dd',
    lp_campaign_key: 'zdZLB3KTqmJ6X9h2VWpt'
  },
  'jafb2': { // James FB 2
    lp_campaign_id: '69058669ebf1e',
    lp_campaign_key: 'b9QgyNdKFJk2X6V8tzMw'
  },
  'jafb3': { // James FB 3
    lp_campaign_id: '69058676e3e80',
    lp_campaign_key: 'M9vKChJfdXknrmGHjzcy'
  },
  'jafb4': { // James FB 4
    lp_campaign_id: '690586842bc2b',
    lp_campaign_key: 'QbtpYgzrqTMCjNkcXRVJ'
  },
  'jafb4e': { // James FB 4 EMP
    lp_campaign_id: '695d0b9cd206a',
    lp_campaign_key: 'dJRwVKfFgmZP6CWkGqcN'
  },
  'e3': { // E FB 3
    lp_campaign_id: '68013708ddfb6',
    lp_campaign_key: 'J8RCrkTVnwhXYWfyBKzp'
  },
  'j3': { // J FB 3
    lp_campaign_id: '6801375a29863',
    lp_campaign_key: 'txnB7wj2fRpMZdgDGHC8'
  },
  'kfb': { // Keenan FB
    lp_campaign_id: '67eee9f6032ed',
    lp_campaign_key: 'MgZcYRW9zwtqXK872VFb'
  },
  'kfb1': { // Keenan FB 1
    lp_campaign_id: '68fff1fd3ed5b',
    lp_campaign_key: '3Bd4RmJwVFvjYPtGL6gk'
  },
  'kfb2': { // Keenan FB 2
    lp_campaign_id: '68fff20ce5bf8',
    lp_campaign_key: 'hG4MHJt9rgfndKXZwRmY'
  },
  'kfb3': { // Keenan FB 3
    lp_campaign_id: '68fff22192741',
    lp_campaign_key: 'ywKFhYdrXNJV4BxG78Z3'
  },
  'kfb4': { // Keenan FB 4
    lp_campaign_id: '67eee9f6032ed',
    lp_campaign_key: 'MgZcYRW9zwtqXK872VFb'
  },
  'kfb4e': { // Keenan FB 4 EMP
    lp_campaign_id: '695c3ef96b118',
    lp_campaign_key: 'pJbzkrMQg8mwNfhW7RTc'
  },
  'kfsf': { // Keenan FB Short Form
    lp_campaign_id: '69e9f7ed6d55f',
    lp_campaign_key: 'yNPDx8M2HbWjmTQKcZd9'
  },
  'kfb5': { // Keenan FB 5
    lp_campaign_id: '6914fd2e963d1',
    lp_campaign_key: '8kqt7Dr9FYCdH4VTgnmJ'
  },
  'ro': { // Keenan FB 2
    lp_campaign_id: '68197250eee40',
    lp_campaign_key: 'JNq9WHRb4F2wTBQxfCv7'
  },
  'ktt': { // Keenan TikTok
    lp_campaign_id: '67eee8881f83d',
    lp_campaign_key: 'kG4CHPyKZV6znRBJDwdL'
  },
  'kttd': { // Keenan TikTok with Disclaimer
    lp_campaign_id: '67eee8881f83d',
    lp_campaign_key: 'kG4CHPyKZV6znRBJDwdL'
  },
  'ktt2': { // Keenan TikTok 2
    lp_campaign_id: '6834bbd18eafb',
    lp_campaign_key: 'C7PMZNVpFxckzhRBtQJy'
  },
  'ktt3': { // Keenan TikTok 3
    lp_campaign_id: '6834bbbf7acfe',
    lp_campaign_key: 'h8zgxRBfFdJtyWwGKP9v'
  },
  'ktt4': { // Keenan TikTok 4
    lp_campaign_id: '6834bbaed3ae6',
    lp_campaign_key: 'jrkq8ypzvFLKYMQwd9JH'
  },
  'jgbn': { // J FB New (98)
    lp_campaign_id: '67a3b5ace20cd',
    lp_campaign_key: 'gYvGLX3MVjP7FTQnhWrB'
  },
  'al': { // AppLovin
    lp_campaign_id: '67aa53b479fa3',
    lp_campaign_key: '78QwZJbcWnCG3xYR4tNX'
  },
  'vtv': { // Vibe TV
    lp_campaign_id: '67b6618de0b13',
    lp_campaign_key: 'hNmxFVjBzypqg2RDfJrT'
  },
  'fab': {
    lp_campaign_id: '66b3a10f768ba',
    lp_campaign_key: 'xFVrjpGdmLbWMc9yfYzC'
  },
  'pt': { // Pinterest
    lp_campaign_id: '66f5bf3fb121e',
    lp_campaign_key: 'zpthk6MjN79JWLyBgPYb'
  },
  '5': { // BMM mail
    lp_campaign_id: '66c64d873df4b',
    lp_campaign_key: 'LmJgtXc67h83V49MdGxK'
  },
  '12': { // LGD mail - New Everflow
    lp_campaign_id: '66c652cf8f0ac',
    lp_campaign_key: 'DNj2Vw6zHXnvFRWPrqyL'
  },
  '43': { // Rooftop / Madrivo
    lp_campaign_id: '683f4f4d44a81',
    lp_campaign_key: '24FfPzZmTjKWyNpk3vcM'
  },
  '15': { // Live Oak
    lp_campaign_id: '66e8b61c67d0c',
    lp_campaign_key: 'mMrNwZfhyYJgG6p7Tc9R',
  },
  'sa': { // Sniper Ads
    lp_campaign_id: '66e8b88869d10',
    lp_campaign_key: 'kZz72rfbKpD4HVgMRyvP'
  },
  'sctt': { // Scintilla TikTok
    lp_campaign_id: '675c66c0a8d22',
    lp_campaign_key: 'QDwTkdXtYRPN9fZMxzLG',
    everflow_aff_id: '21',
    everflow_offer_id: 1
  },
  'scfb1': { // Scintilla FB 1
    lp_campaign_id: '691bc32b48564',
    lp_campaign_key: 'QhT8Z4mnMwqbjLRrGYXv',
    everflow_aff_id: '21',
    everflow_offer_id: 2
  },
  'scfb2': { // Scintilla FB 2
    lp_campaign_id: '691bc33ba54eb',
    lp_campaign_key: 'r9Vj6nWBXp384qfTyJMt',
    everflow_aff_id: '21',
    everflow_offer_id: 1
  },
  'sc': { // Scintilla TikTok 2
    lp_campaign_id: '675c6747d53ea',
    lp_campaign_key: '6CHdQWqbLMDwryPNKXpY',
    everflow_aff_id: '21',
    everflow_offer_id: 2
  },
  'sctf': { // Scintilla TikTok 5
    lp_campaign_id: '68b8599469d22',
    lp_campaign_key: 'KrLZYGcQ8nM2zCHNgVwb',
    everflow_aff_id: '21',
    everflow_offer_id: 40
  },
  'stt': { // Scintilla TikTok
    lp_campaign_id: '6859c8439259d',
    lp_campaign_key: '7rFCmRdXV2WJZhpGQqPY',
    everflow_aff_id: '21',
    everflow_offer_id: 4
  },
  'cvtt': { // Click Ventures TikTok
    lp_campaign_id: '675c6519d5935',
    lp_campaign_key: 'KvVHNjzgX7mQB8T2f64G',
    everflow_aff_id: '6',
    everflow_offer_id: 1
  },
  'cvk': { // Click Ventures 2
    lp_campaign_id: '675c6616e783d',
    lp_campaign_key: 'FPLYqJQdxG42VbCXzMtc',
    everflow_aff_id: '7',
    everflow_offer_id: 1
  },
  'cvfb': { // Click Ventures FB
    lp_campaign_id: '675c65a4ca629',
    lp_campaign_key: '8mdyHxLMwRVWZftXbgv6',
    everflow_aff_id: '6',
    everflow_offer_id: 2
  },
  'cvfb2': { // Click Ventures FB 2
    lp_campaign_id: '69f875465c88c',
    lp_campaign_key: 'LmNx3TGtRW2XJBhfqY8d',
    everflow_aff_id: '6',
    everflow_offer_id: 3
  },
  'cvtt2': { // Click Ventures TT 2
    lp_campaign_id: '69f8756249307',
    lp_campaign_key: 'yhRxFw7qjf6pJd9NBYr8',
    everflow_aff_id: '6',
    everflow_offer_id: 4
  },
  'env': { // Elise non verified
    lp_campaign_id: '67020f8ebce46',
    lp_campaign_key: 'bBP3CMgwVdY8k7ZLxcRp'
  },
  'sg': { // Salius Gabe
    lp_campaign_id: '675c67a68f3b6',
    lp_campaign_key: 'nxXrfpYV9c7GZ83mtT6z',
    everflow_aff_id: '19',
    everflow_offer_id: 1
  },
  'sm': { // Salius Martin
    lp_campaign_id: '67864d4788000',
    lp_campaign_key: 'dqVMDnbvF64typwZzK3f',
    everflow_aff_id: '27',
    everflow_offer_id: 1
  },
  'sp': { // Salius Peduzzi
    lp_campaign_id: '686544a6852b3',
    lp_campaign_key: 'BznHgW82GRPbCQwFXM36',
    everflow_aff_id: '20',
    everflow_offer_id: 1
  },
  'gfb': { // Griffen FB
    lp_campaign_id: '675c68061746d',
    lp_campaign_key: 'gwVPp8WkdJchnjXGFHmf',
    everflow_aff_id: '22',
    everflow_offer_id: 1
  },
  'gfb2': { // Griffen FB
    lp_campaign_id: '68efafc08ccda',
    lp_campaign_key: 'nGhJc69WXLpkvZTHy2mY',
    everflow_aff_id: '22',
    everflow_offer_id: 1
  },
  '682cded13ec669a5945c1f9f': { // tt reviews
    lp_campaign_id: '67eee8881f83d',
    lp_campaign_key: 'kG4CHPyKZV6znRBJDwdL'
  },
  '68adeaa82c53319c6b04dffb': { // Nico fb reviews
    lp_campaign_id: '68adec8d6230c',
    lp_campaign_key: '4Z8HJKRVz2PrGjqfTdFx'
  },
  '682cfc1f3ec669a59462d693': { // tt article
    lp_campaign_id: '67eee8881f83d',
    lp_campaign_key: 'kG4CHPyKZV6znRBJDwdL'
  },
  '682e39e614650ee04fe31c07': { // tt zip LP
    lp_campaign_id: '67eee8881f83d',
    lp_campaign_key: 'kG4CHPyKZV6znRBJDwdL'
  },
  '6830d9e2fbb1598e0a3a29e4': { // tt map LP
    lp_campaign_id: '67eee8881f83d',
    lp_campaign_key: 'kG4CHPyKZV6znRBJDwdL'
  },
  '682b725ed43fb1a077f8b871': { // yt reviews
    lp_campaign_id: '66f6dfef42c67',
    lp_campaign_key: 'y7gW4TLZGpj2rq6HKMnJ'
  },
  '682cec75013e261d510b34af': { // yt df article
    lp_campaign_id: '66f6dfef42c67',
    lp_campaign_key: 'y7gW4TLZGpj2rq6HKMnJ'
  },
  'gnb': { // Griffen Newsbreak
    lp_campaign_id: '67d35746a6bed',
    lp_campaign_key: 'D4wtYcHdxRLCJnrXvzMy',
    everflow_aff_id: '22',
    everflow_offer_id: 3
  },
  'gyt': { // Griffen YT
    lp_campaign_id: '67106a1969a29',
    lp_campaign_key: '8xTGfKLDnWCrg62Q4w7z',
    click_campaign_id: '38',
    everflow_aff_id: '22',
    everflow_offer_id: 2
  },
  'll': { // James Legacy Leads
    lp_campaign_id: '6774efb76d146',
    lp_campaign_key: 'Hdm9z4gBkjYWJGvRM7DT',
    everflow_aff_id: '14',
    everflow_offer_id: 1
  },
  'ssc': { // Scintilla Snapchat
    lp_campaign_id: '675c6666a1257',
    lp_campaign_key: 'xDNZg3XwWzK6CrYcRQV2',
    everflow_aff_id: '21',
    everflow_offer_id: 3
  },
  'sct': { // Scintilla Twitter
    lp_campaign_id: '678e7f7f9323e',
    lp_campaign_key: 'XtjVQxJv7GRC3FL2y6MD',
    everflow_aff_id: '21',
    everflow_offer_id: 4
  },
  'cy': { // CY (Carter York)
    lp_campaign_id: '6900e9443a80c',
    lp_campaign_key: 'F8cf9CjnzXDHR674vNPy',
    everflow_aff_id: '8',
    everflow_offer_id: 1
  },
  'efb': { // Elise FB 2
    lp_campaign_id: '6723e11fa54ad',
    lp_campaign_key: 'KRJZkzB3nVFYtfXPQypD'
  },
  'jfb': { // Justine FB 2
    lp_campaign_id: '6723e1327e697',
    lp_campaign_key: 'qtFHwCWxZKjRNcDgrMY4'
  },
  'jcrs': { // Justine FB CRS
    lp_campaign_id: '6977abeacf39a',
    lp_campaign_key: 'bR8ZHLTyMnW4Gdz2hjN3'
  },
  'jfbe': { // Justine FB Employed
    lp_campaign_id: '68ff8cf514ca6',
    lp_campaign_key: 'Xr8MF3fQqbd7kZJNTx4L'
  },
  'jfb1': { // Justine FB 1
    lp_campaign_id: '69052ecd8891b',
    lp_campaign_key: 'xYnCyMbZX4PmL89N6GQ7'
  },
  'jfb2': { // Justine FB 2
    lp_campaign_id: '6723e1327e697',
    lp_campaign_key: 'qtFHwCWxZKjRNcDgrMY4'
  },
  'jfb3': { // Justine FB 3
    lp_campaign_id: '69058507e666d',
    lp_campaign_key: 'XVMDxHFRwTfCd96rpzJW'
  },
  'jfb4': { // Justine FB 4
    lp_campaign_id: '690585185a298',
    lp_campaign_key: 'dX6wQMYZxbBLFvpczhy4'
  },
  'jfb1e': { // Justine FB 1 Employed
    lp_campaign_id: '6905852a23dc6',
    lp_campaign_key: 'CrwmDpNMyYvhtg8GfR2F'
  },
  'jfbn': { // Justine FB 3
    lp_campaign_id: '67645bd06a5ad',
    lp_campaign_key: 'VDPgbBnYWHTtJKMq92jr'
  },
  'nfb': { // Nico FB
    lp_campaign_id: '672e356d32995',
    lp_campaign_key: 'ZyxBC3JmYH7c9jDqTp2K'
  },
  'nb': { // Nico Newsbreak
    lp_campaign_id: '678ebedcbb034',
    lp_campaign_key: 'YTMyj3V7bcCrhQFG9dgw'
  },
  'ndb': { // NDB Offer Wall
    lp_campaign_id: '6734d9d4ba383',
    lp_campaign_key: '8x2qmPLXyhKBZYRbvNjk',
    everflow_aff_id: '16',
    everflow_offer_id: 1
  },
  'sn': { // Salius Nick
    lp_campaign_id: '675c754725e9e',
    lp_campaign_key: 'yFPj3Dvx7K4tc9qbfZwg',
    everflow_aff_id: '26',
    everflow_offer_id: 1
  },
  'kj': { // Koji
    lp_campaign_id: '675c75a35c1dd',
    lp_campaign_key: '26xpnV98rGhNdMvWgPkf',
    everflow_aff_id: '10',
    everflow_offer_id: 1
  },
  'tbb': { // Taboola Blake
    lp_campaign_id: '6839eca42aefb',
    lp_campaign_key: 'WLbGFQCNYJvD6T7pcfHK'
  },
  'rcb': { // Rev Content Blake
    lp_campaign_id: '6842094d4a530',
    lp_campaign_key: 'jFdQ7tW98D63V2pxYmXL'
  },
  'bfb': { // Blake FB
    lp_campaign_id: '673cc73c0fed4',
    lp_campaign_key: 'RzDvCJgpnW7c2MLyb6TP'
  },
  're': { // Ridgeville Entities (Arbmaniac)
    lp_campaign_id: '673f8c1006991',
    lp_campaign_key: 'rgFQTC8DnfKkzwytXpLM',
    everflow_aff_id: '17',
    everflow_offer_id: 1
  },
  'pzfb': { // PZ FB2
    lp_campaign_id: '674d39293e50f',
    lp_campaign_key: '28w4k3PnhJpHYR7rxmZc',
    everflow_aff_id: '13',
    everflow_offer_id: 2
  },
  'lgfb': { // PZ FB1
    lp_campaign_id: '674d390c84945',
    lp_campaign_key: 'qftd4zLPb37HhnWGMyBk',
    everflow_aff_id: '49',
    everflow_offer_id: 1
  },
  'spc': { // Spataro Connor New
    lp_campaign_id: '690a798625c9d',
    lp_campaign_key: 'cq7FLGjvJChVRNPMn2zk',
    everflow_aff_id: '49',
    everflow_offer_id: 1
  },
  'lgg': { // PZ Google
    lp_campaign_id: '674d39421d41e',
    lp_campaign_key: 'Q34nxH2fYKLvNXzp6cFr',
    everflow_aff_id: '13',
    everflow_offer_id: 3
  },
  'tk': { // 2 Kings Arvin
    lp_campaign_id: '675c6979df72a',
    lp_campaign_key: '6CdRxgr7vbXMTHNyDnj9',
    everflow_aff_id: '4',
    everflow_offer_id: 1
  },
  'bs': { // Email
    lp_campaign_id: '6751d5f85e6de',
    lp_campaign_key: '4pcLCg29wvWB8NDjH6Rr',
    everflow_aff_id: '9',
    everflow_offer_id: 1
  },
  '9': { // Email
    lp_campaign_id: '6751d5f85e6de',
    lp_campaign_key: '4pcLCg29wvWB8NDjH6Rr'
  },
  'faa': { // PZ FB3 - First Advantage Associates
    lp_campaign_id: '67570dae4a92b',
    lp_campaign_key: 'hpfFq9MmHj2QgXrZkx4N',
    everflow_aff_id: '49',
    everflow_offer_id: 2
  },
  'spb': { // Spataro Bo New
    lp_campaign_id: '690a7973ad319',
    lp_campaign_key: 'gHzK8TChDZFwXB4MY3GN',
    everflow_aff_id: '49',
    everflow_offer_id: 2
  },
  'kyt': { // Kyle YT
    lp_campaign_id: '6771ac4258a97',
    lp_campaign_key: 'WV2M8Z6kFK9HwxhPcTmb',
    everflow_aff_id: '11',
    everflow_offer_id: 1
  },
  '11': { // Kyle SMS
    lp_campaign_id: '69b96a6e25ad9',
    lp_campaign_key: '7WxLXQNrt8hqHP3zVKkv'
  },
  'rsg': { // Scibelli Google
    lp_campaign_id: '67c70e4461098',
    lp_campaign_key: 'jvKPXGy96WrYd2BJMCpm',
    click_campaign_id: '109',
    everflow_aff_id: '23',
    everflow_offer_id: 1
  },
  '23': { // Scibelli YT
    lp_campaign_id: '677cfd830d15b',
    lp_campaign_key: 'Rxy9LVG6BfXd3z2FbKpt'
  },
  'sfa': { // Spataro
    lp_campaign_id: '67882a1edb380',
    lp_campaign_key: '6Cd4Bwx9Z8WvgNrk2Mmj',
    everflow_aff_id: '28',
    everflow_offer_id: 1
  },
  'sfa2': { // Spataro 2
    lp_campaign_id: '68508336e5b9a',
    lp_campaign_key: 'xhZzPcN8qfjwTtbL3KmC',
    everflow_aff_id: '28',
    everflow_offer_id: 2
  },
  'sfa3': { // Spataro 3
    lp_campaign_id: '68508349da844',
    lp_campaign_key: 'LDdyZTYCBQqFKG4xh3z7',
    everflow_aff_id: '28',
    everflow_offer_id: 3
  },
  'sfa4': { // Spataro 4
    lp_campaign_id: '6850835a8a122',
    lp_campaign_key: 'tQNWMk8Lq7pYwdgDJcxn',
    everflow_aff_id: '28',
    everflow_offer_id: 4
  },
  'sfa5': { // Spataro 5
    lp_campaign_id: '6850836ba2bb4',
    lp_campaign_key: 'R2NgVHmh8r6CpGF7YMPv',
    everflow_aff_id: '28',
    everflow_offer_id: 29
  },
  'rsv1': { // Spataro RSV1
    lp_campaign_id: '6859cbb3364fc',
    lp_campaign_key: 'KGbx4VmQjXLPYtwBvRck',
    everflow_aff_id: '49',
    everflow_offer_id: 3
  },
  'sfb4': { // Spataro FB4
    lp_campaign_id: '685ee44f32137',
    lp_campaign_key: 'ZrGzBRqyNHpwDd2kchM3',
    everflow_aff_id: '49',
    everflow_offer_id: 4
  },
  '29': { // MassConnect Email
    lp_campaign_id: '67aa4b1f6f709',
    lp_campaign_key: 'ghnbYdG23BJ6QVFwHcK4',
    everflow_aff_id: '29',
    everflow_offer_id: 1
  },
  '291': { // MassConnect Email
    lp_campaign_id: '67aa4b1f6f709',
    lp_campaign_key: 'ghnbYdG23BJ6QVFwHcK4',
  },
  '292': { // Mass Connect Path
    lp_campaign_id: '67aa4b2ebd7dc',
    lp_campaign_key: 'r7RZQgfDnLjKMTwFWdCk',
  },
  'mg': { // Media Gravy
    lp_campaign_id: '67aa4c79296b0',
    lp_campaign_key: 'cjzpMQmrBR2bqfkPGtgy',
    everflow_aff_id: '30',
    everflow_offer_id: 1
  },
  '311': { // Z3 Native
    lp_campaign_id: '6807b81f8e68a',
    lp_campaign_key: 'CjBbFTnQM8DvNdY3WrhL'
  },
  'jo': { // Jeanette Organic
    lp_campaign_id: '67b3b43c91a4f',
    lp_campaign_key: 'y9Z6ndxgwhf24QMrkG3c'
  },
  'io': { // Internal Organic
    lp_campaign_id: '67b3b4af0a4ba',
    lp_campaign_key: 'RFnb2fqWyZ48hwGJMHCz'
  },
  '32': { // Flex Email
    lp_campaign_id: '67b4b6f357f0f',
    lp_campaign_key: '8FPHzxQnwC4jDvGdMbqg',
  },
  '34': { // Banner Edge
    lp_campaign_id: '67cf6566473bc',
    lp_campaign_key: 'n9jyJXKH8q7wcbLT2Rx6',
  },
  'scal': { // Scalability
    lp_campaign_id: '67d1b9d401ad5',
    lp_campaign_key: 'PtrbdRVjHQZgmkwvLNzx',
    everflow_aff_id: '35',
    everflow_offer_id: 1
  },
  'de': { // Definitive Edge Main
    lp_campaign_id: '68017e7ae2cf9',
    lp_campaign_key: 'LFcNmhM9QyHKbfrRVjnG',
    everflow_aff_id: '36',
    everflow_offer_id: 4
  },
  'der': { // Definitive Edge Reddit
    lp_campaign_id: '67e7132c07beb',
    lp_campaign_key: 'TzdVvxnrwqPFhRcW987N',
    everflow_aff_id: '36',
    everflow_offer_id: 1
  },
  'dett': { // Definitive Edge TikTok
    lp_campaign_id: '67e713f122b79',
    lp_campaign_key: 'kG2QbJyxVDm9jWBnTqPL',
    everflow_aff_id: '36',
    everflow_offer_id: 2
  },
  'defb': { // Definitive Edge Facebook
    lp_campaign_id: '67e7141261fc1',
    lp_campaign_key: '9xKVNZFywrMDt6Gj4Hkc',
    everflow_aff_id: '36',
    everflow_offer_id: 3
  },
  '38': { // iDrive Email
    lp_campaign_id: '67f99a1b6aecd',
    lp_campaign_key: 'gBPhX6pnyxHcJwDR98Yr',
  },
  '39': { // Shift44 Email
    lp_campaign_id: '68190501e9ca1',
    lp_campaign_key: 'PFXqzt4TgC3pjybw2MZV',
  },
  'dlf': { // Dashleads FB
    lp_campaign_id: '681ce0535a9e6',
    lp_campaign_key: 'mBjt7yNZ4TgdVrQM2hPW',
    everflow_aff_id: '40',
    everflow_offer_id: 1
  },
  'dlt': { // Dashleads TT
    lp_campaign_id: '681ce3b84b1eb',
    lp_campaign_key: 'WP28r3hjR4dH7bgGqDNy',
    everflow_aff_id: '40',
    everflow_offer_id: 2
  },
  '41': { // NDB Email Drops
    lp_campaign_id: '682d0367df65c',
    lp_campaign_key: '6MxgtVm4YvXjQPNqWzF7'
  },
  '441': { // RDG Taboola
    lp_campaign_id: '68420015d39a4',
    lp_campaign_key: 'bDcFhPnRJTyBWjg4Gt6q',
  },
  '442': { // RDG Outbrain
    lp_campaign_id: '68420029924cb',
    lp_campaign_key: 'qmVtnHb78kgW6dLBvYfQ',
  },
  '421': { // Deltos Email
    lp_campaign_id: '6840c2259ca27',
    lp_campaign_key: 'H2R8zDNJqtfC7gjMKnQW',
  },
  '422': { // Deltos Display
    lp_campaign_id: '6840c258bf3de',
    lp_campaign_key: 'fFQ9RVJxrWzd3pvwYTP7',
  },
  '423': { // Deltos SMS
    lp_campaign_id: '6840c284e0cd8',
    lp_campaign_key: 'hXWYLyCgqDf4vPkp6j82',
  },
  '424': { // Deltos Display 2
    lp_campaign_id: '68e6753ae8868',
    lp_campaign_key: '67z4VgdL8XJwnfm93hKT',
  },
  'cn': { // Charmander Native
    lp_campaign_id: '6852f8c7cb573',
    lp_campaign_key: 'hdQt89LP4xzWGRFZpCyk',
    everflow_aff_id: '50',
    everflow_offer_id: 1
  },
  'ctt': { // Charmander Tiktok
    lp_campaign_id: '6852f8dc3c9cc',
    lp_campaign_key: 'z27JXBTQW69KNnvYyM3G',
    everflow_aff_id: '50',
    everflow_offer_id: 2
  },
  'bn': { // Belighten Native
    lp_campaign_id: '68530122e6c56',
    lp_campaign_key: 'P4GbcxrKhV9pdq6Mzj3J',
    everflow_aff_id: '51',
    everflow_offer_id: 1
  },
  'btt': { // Belighten Tiktok
    lp_campaign_id: '685301b9d435f',
    lp_campaign_key: 'ZmpNPrcw2zLQKqg9FfBT',
    everflow_aff_id: '51',
    everflow_offer_id: 2
  },
  'befb': { // Belighten Facebook
    lp_campaign_id: '689b829457209',
    lp_campaign_key: 'ZqmNTXn3FGr7bH8gBJkh',
    everflow_aff_id: '51',
    everflow_offer_id: 3
  },
  'ud': { // Udonis
    lp_campaign_id: '685433a0a5f48',
    lp_campaign_key: '3z2cbdDHN9qRQWvYykmC',
    everflow_aff_id: '52',
    everflow_offer_id: 1
  },
  'rm': { // Run Media Tiktok
    lp_campaign_id: '68555d95b9d8e',
    lp_campaign_key: '3qYGw6jD4zbpPNxQVT8L',
    everflow_aff_id: '53',
    everflow_offer_id: 1
  },
  '53': { // Run Media Tiktok
    lp_campaign_id: '68555d95b9d8e',
    lp_campaign_key: '3qYGw6jD4zbpPNxQVT8L'
  },
  'rvm': { // RVM
    lp_campaign_id: '686576a04702a',
    lp_campaign_key: 'jXrw6dLbM8xKpGvqHNT3'
  },
  '55': { // AdCentral
    lp_campaign_id: '686fae69afb9e',
    lp_campaign_key: 'bmR8NYjGvVd4QhMnWkX9'
  },
  '561': { // USM
    lp_campaign_id: '6875701d18e21',
    lp_campaign_key: 'WcdJtpqRBYb62CmhDjHV'
  },
  '562': { // USM
    lp_campaign_id: '69af2e491027c',
    lp_campaign_key: 'G86LDFWgcPMB2vmhdpH9'
  },
  '57': { // USM
    lp_campaign_id: '6876641959a6e',
    lp_campaign_key: '9CxzBtLj8HfGRhg6cP2N'
  },
  '59': { // Webit
    lp_campaign_id: '6880dd627b881',
    lp_campaign_key: 'g84kV6GwcNQHtRDymqfW'
  },
  '60': { // Goose TikTok
    lp_campaign_id: '689b7aa628666',
    lp_campaign_key: 'ZBpWw7g3ChyQGc2mJT4b'
  },
  '61': { // YDS Dynamic Listicle
    lp_campaign_id: '68a72808c17cc',
    lp_campaign_key: '4RnmxHwftTzZJb7dFBjY'
  },
  '66': { // BMM Everflow
    lp_campaign_id: '690a49bd4407a',
    lp_campaign_key: 'TV3FzPmbMNRGhK6knpgL'
  },
  '621': { // Scale Club Native
    lp_campaign_id: '68a5b79d2e827',
    lp_campaign_key: 'X7C62h3WLtTGcYb9VHwd'
  },
  '622': { // Scale Club TikTok
    lp_campaign_id: '68a5b8a7ba31e',
    lp_campaign_key: 'VyhFTn4G8ZMcNPRd2gzq'
  },
  '623': { // Scale Club Meta
    lp_campaign_id: '690a7912515c1',
    lp_campaign_key: 'NLnDJCYTkFyGqwp2gZmv'
  },
  '631': { // IDS Native
    lp_campaign_id: '68a5bab7b7a5b',
    lp_campaign_key: 'B6Dt392KbXfvGPLkHFrp'
  },
  '632': { // IDS TikTok
    lp_campaign_id: '68a5bb3ac93d2',
    lp_campaign_key: 'n2ZXjQGyhPVtmBNbr49w'
  },
  '633': { // IDS Meta
    lp_campaign_id: '68dd3c5dd2c76',
    lp_campaign_key: 'DyrvThCJn3FW4kLM9Z8X'
  },
  '64': { // PigeonFi Native
    lp_campaign_id: '68a5cab444b9a',
    lp_campaign_key: 'wFqgM2ykQp6Vrz3dXmcx'
  },
  '67': { // Maverick 2
    lp_campaign_id: '68ade49c3d471',
    lp_campaign_key: 'T24kt6yQZcmGWbNDpv9d'
  },
  '691': { // Flybridge Native
    lp_campaign_id: '68bf70cb64844',
    lp_campaign_key: 'BnmRzdY87HQxyMkg32Z4'
  },
  '692': { // Flybridge TikTok
    lp_campaign_id: '68bf7183bec5a',
    lp_campaign_key: 'HwcpBtRdQrJmPhyzNMGq'
  },
  '693': { // Flybridge Google
    lp_campaign_id: '68bf7228d1886',
    lp_campaign_key: 'Bt4jPq78b6gJzpQZxkmX'
  },
  '701': { // Rubicon Native
    lp_campaign_id: '68c2fb04a7ffc',
    lp_campaign_key: '8fGcp3dxNFQZhRPtHk6L'
  },
  '702': { // Rubicon TikTok
    lp_campaign_id: '68c2fba4114fa',
    lp_campaign_key: 'qD6FL2CMynbJKv9Z8Y7j'
  },
  '703': { // Rubicon Listicle
    lp_campaign_id: '68c84bad5ce3c',
    lp_campaign_key: '64VDTHKgJrkqQFWywh9G'
  },
  '711': { // MiamiMedia Email
    lp_campaign_id: '68c4109e128c8',
    lp_campaign_key: '8R6nGdz4Q7rfJCxYNyqc'
  },
  '712': { // MiamiMedia SMS
    lp_campaign_id: '68c411007aa35',
    lp_campaign_key: 'yrQxZ6qPcYkB42pjvMN3'
  },
  'fsn': { // Front Story Native
    lp_campaign_id: '68c9ec0c519ab',
    lp_campaign_key: '3ycnkQgpwxV6HB2mrfLX',
    everflow_aff_id: '72',
    everflow_offer_id: 1
  },
  'fsm': { // Front Story Meta
    lp_campaign_id: '68c9ec36ba777',
    lp_campaign_key: 'TYLd86Zgp7MWCmxVj2NR',
    everflow_aff_id: '72',
    everflow_offer_id: 2
  },
  'jjy': { // JJ Dopamiin Media Youtube
    lp_campaign_id: '68dc4123486ac',
    lp_campaign_key: 'H2FYgQhCXxfbGckLNmJr',
    everflow_aff_id: '73',
    everflow_offer_id: 1
  },
  'jjm': { // JJ Dopamiin Media Meta
    lp_campaign_id: '68dc422578723',
    lp_campaign_key: 'qH2RkWx6rd3LJTBVjN7y',
    everflow_aff_id: '73',
    everflow_offer_id: 2
  },
  'lda': { // Louding Ads Meta
    lp_campaign_id: '68e42ed8732c4',
    lp_campaign_key: 'WhjBT7RNntcYGCfKFQyz',
    everflow_aff_id: '75',
    everflow_offer_id: 1
  },
  '74': { // Spark Revenue Email
    lp_campaign_id: '68e3df6fe0fb0',
    lp_campaign_key: 'zQrc8P6BTjFwdqp3b2G4'
  },
  '76': { // Rxtra
    lp_campaign_id: '68e6774ad9d74',
    lp_campaign_key: 'vZK2dtbpLhgx89fPcjVM'
  },
  '78': { // Zeta
    lp_campaign_id: '6925d36d893b0',
    lp_campaign_key: 'mJCz2LTGrjc6XYVf4w7d'
  },
  'fblf': { // FB Lead Forms
    lp_campaign_id: '6925c33330b9a',
    lp_campaign_key: 'wBJHbL8mY3PdjcnxfMv9'
  },
  'ree': { // ReEngage
    lp_campaign_id: '6936cde24eb6d',
    lp_campaign_key: 'Q7bhWLTxfNPDFk496yBd',
    everflow_aff_id: '81',
    everflow_offer_id: 1
  },
  'mfs': { // Media Force Search
    lp_campaign_id: '696168e87a08b',
    lp_campaign_key: 'DLWzjm3YVbn9wB8hqJ6v',
    everflow_aff_id: '85',
    everflow_offer_id: 1
  },
  'mfn': { // Media Force Native
    lp_campaign_id: '696168d8bd1c9',
    lp_campaign_key: 'Lf84bz7ZXM3pKHkNC9jw',
    everflow_aff_id: '85',
    everflow_offer_id: 2
  },
  'gs': { // Google Search
    lp_campaign_id: '66e8ba560d56a',
    lp_campaign_key: '42ZXCVtbgN8jRhxFWJG9'
  },
  'nd': {
    lp_campaign_id: '69744776b7e5f',
    lp_campaign_key: '3dKrVfQH2kxqtwn746Fc'
  },
  'jnsp': {
    lp_campaign_id: '697cae777b1a1',
    lp_campaign_key: 'D3rNwQMLKfm9h8BjPVH4'
  },
  '88': { // Apex
    lp_campaign_id: '697a568a12422',
    lp_campaign_key: 'hFc6tfnNPmqyCV9ZBLJx'
  },
  '89': { // infinity box
    lp_campaign_id: '6983b94393377',
    lp_campaign_key: 'yvVr9XFYGB6dPwQWMTmg'
  },
  '921': { // GoodClicks Mailer
    lp_campaign_id: '699e115f722dd',
    lp_campaign_key: 'CtR3LGWzqZX2HVDbr9Jx'
  },
  '922': { // GoodClicks Mailer
    lp_campaign_id: '699e116c33f4a',
    lp_campaign_key: '2XxHwTp6JQZfCMqgKb3z'
  },
  '923': { // GoodClicks Mailer
    lp_campaign_id: '699e1177c8f28',
    lp_campaign_key: 'fwhTMbqmKW3yBdjx76nk'
  },
  '924': { // GoodClicks Mailer
    lp_campaign_id: '699e1185201b9',
    lp_campaign_key: 'd82pkr3vFKnwGjCzgq97'
  },
  '925': { // GoodClicks Mailer
    lp_campaign_id: '699e118fede9e',
    lp_campaign_key: '3VPQBkZgztqNc9LKDw7G'
  },
  '93': { // B Two Direct
    lp_campaign_id: '699e13ae16d58',
    lp_campaign_key: 'wFzxRjXTqfyrYLG6CB3t'
  },
  '94': { // Scale Up Media
    lp_campaign_id: '69a85870840f9',
    lp_campaign_key: 'WR2vtYNZrVQ8DyhgxFBp'
  },
  '97': { //PureAds Email
    lp_campaign_id: '69b30126b832c',
    lp_campaign_key: '7Fc3y42m6wgVx8rLJvPk'
  },
  '95': { // Motive Native
    lp_campaign_id: '69af51d2cb2c8',
    lp_campaign_key: 'nDLTb2CMywPpcVtrKYRJ'
  },
  '991': { // Teapot Comparison Email
    lp_campaign_id: '69b9638ada0ac',
    lp_campaign_key: 'kqcBhMPdfJY7z9HCx2tW'
  },
  '992': { // Teapot Email #2
    lp_campaign_id: '69bac764b49e1',
    lp_campaign_key: '762nTrWZMmtkHvJqPBY4'
  },
  '961': { // Strand Native
    lp_campaign_id: '69b098d51a84a',
    lp_campaign_key: '4WyH6MzR2XfFdGhbpxgt'
  },
  '962': { // Strand Email
    lp_campaign_id: '69ebaec4c8237',
    lp_campaign_key: 'rMzxfQpFJYGwvKdg8WXc'
  },
  '963': { // Strand Native 2
    lp_campaign_id: '6a07542988023',
    lp_campaign_key: 'DMwfKJj8k27RqhZFHYng'
  },
  '108': { // Secco Email
    lp_campaign_id: '69fa379675426',
    lp_campaign_key: 'KGHgQxFmtVYqZfDc8TMN'
  },
  '981': { // Creative Clicks
    lp_campaign_id: '69b44071c1508',
    lp_campaign_key: 'nBNtkm9fqyZwW8RVQXxv'
  },
  '981': { // Creative Clicks Email
    lp_campaign_id: '69b441043d586',
    lp_campaign_key: '3yQKNjWGDFvP9tLcZhRn'
  },
  '983': { // Creative Clicks Meta
    lp_campaign_id: '6a05eb4eb2b03',
    lp_campaign_key: 'GN9KyVv3wHY87ZnpxMXb'
  },
  '101': { // Vcommission Meta
    lp_campaign_id: '69c2caa71e2ca',
    lp_campaign_key: 'qx2DcywNnMQgJvjH6Gkd'
  },
  '1021': { // Schemathics Meta
    lp_campaign_id: '69c2c6b26077a',
    lp_campaign_key: 'jBWvhbHfJDk8cq37ZPMr'
  },
  '1022': { // Schemathics Comparison Site
    lp_campaign_id: '6a07555abfdd8',
    lp_campaign_key: 'ht62BjZVWLgdGqP9KzcR'
  },
  '1051': { // Appstinum Meta
    lp_campaign_id: '69c69492c90e0',
    lp_campaign_key: 'yVBwQdHzCTpRn2X47MkL'
  },
  '1052': { // Appstinum Email
    lp_campaign_id: '69c694faadac6',
    lp_campaign_key: '2VmXHGFvB7kzfPyjgKdr'
  },
  '1061': { // Diablo 1 Wallet Wizard
    lp_campaign_id: '69ce7d4b5b454',
    lp_campaign_key: '8KgDQfxHMNpy3TtwmRFc'
  },
  '1062': { // Diablo 2 Everyday Resources
    lp_campaign_id: '69ce9989c85f3',
    lp_campaign_key: 'zxpvCg8hRBnZy9Y2GXkF'
  },
  '103': { // Assure Media
    lp_campaign_id: '69d669ef592ee',
    lp_campaign_key: 'dXJ8273Ptn9ykGBFxzjr'
  },
  '107': { // Idea Clan
    lp_campaign_id: '69d66c55750e1',
    lp_campaign_key: 'WtpMgZmLPDcJGdKq7Cr4'
  },
  'jpfb': { // JP FB
    lp_campaign_id: '69f87415c6de9',
    lp_campaign_key: 'qNVJpYwTkbF38df2jBgK'
  },
  '111': { // Genesis Meta
    lp_campaign_id: '6a0756468e3c5',
    lp_campaign_key: 'zk6tMR9CBPxbyqTKWjH2'
  }
}

// Affiliates that force EMP mode (always show employment question)
export const FORCE_EMP_AIDS = ['jafb4e', 'kfb4e']

// Affiliates with 30% traffic split to EMP mode
export const EMP_SPLIT_AIDS = ['sct']

// EMP split campaign keys (used when EMP split is active)
export const EMP_SPLIT_KEYS = {
  sct: { lp_campaign_id: '695d0d758c00e', lp_campaign_key: 'LZb9ndxWRKD386qgjykN' },
  gfb: { lp_campaign_id: '695d0e27128c2', lp_campaign_key: 'g29bMNcTYR3wJkWvn8yF' }
}

// Affiliates that skip credit pull (Array/CRS) - debt amount used as verified debt
export const SKIP_CREDIT_AIDS = ['jnsp']

export const DEFAULT_CREDIT_PULL_SETTINGS = {
  primary: 'array',
  fallback: 'crs'
}

const CREDIT_PULL_PRIMARY_VALUES = ['off', 'array', 'crs', 'dual']
const CREDIT_PULL_FALLBACK_VALUES = ['off', 'array', 'crs']

// Affiliates that append oid parameter to aff_id
export const DIRECT_LINK_AFFS = ['29', '31', '44', '42', '62', '63', '69', '70', '71', '92', '56', '99', '98', '105', '106', '96', '102']

// Affiliates that show TikTok disclaimer
export const DISCLAIMER_AIDS = ['kttd', 'ktt2', 'ktt3', 'ktt4', 'stt']

// Domain to affiliate ID mapping
export const DOMAIN_AFF_MAPPING = {
  'go.farelief.com': 'jo',
  'www.farelief.com': 'io',
  'farelief.com': 'io',
  'fadebtrelief.com': 'vtv',
  'www.fadebtrelief.com': 'vtv'
}

// Helper to get campaign keys for an affiliate
export function getCampaignKeysForAff(affId) {
  return campaignKeys[affId] || campaignKeys['0']
}

export function getCreditPullSettingsForCampaign(keys = {}) {
  const creditPull = keys.creditPull || {}
  const primary = CREDIT_PULL_PRIMARY_VALUES.includes(creditPull.primary)
    ? creditPull.primary
    : DEFAULT_CREDIT_PULL_SETTINGS.primary
  const fallback = CREDIT_PULL_FALLBACK_VALUES.includes(creditPull.fallback)
    ? creditPull.fallback
    : DEFAULT_CREDIT_PULL_SETTINGS.fallback

  if (primary === 'off' || primary === 'dual') {
    return { primary, fallback: 'off' }
  }

  if (fallback === primary) {
    return { primary, fallback: 'off' }
  }

  return { primary, fallback }
}
